import { axiosInstance } from '.';
const getPaymentTransactionsList = async (params) => await axiosInstance.get('/payment_transactions', { params });
const ExportPaymentTransactions = async (params) => await axiosInstance.get('/payment_transactions/generate_report', { params });
const ExportSingleSettlement = async (id) => await axiosInstance.get(`/settlements/${id}/export_settlement_items`);

export{
    getPaymentTransactionsList,
    ExportPaymentTransactions,
    ExportSingleSettlement
}